export const phrases = [
  {
    "phrase": "Это все без юая, поэтому всё тут стремное.",
    "author": "Катя Мишина"
  },
  {
    "phrase": "Более лучше стали одеваться виджеты.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Есть гипотеза, что это дело благое.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "У меня, кстати, нет такой реакции на эту стену.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Мы обычно и так на встречах пукаем и крякаем, так что все норм, ничего не потеряешь.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Это противоречит колбасе.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Давайте в этот раз без дикпиков!",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Тоже померюсь длиной своего юикса.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Пилили его два спринта, но все равно он забагованный.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Это вы еще про мой градус каши не слышали.",
    "author": "Настя Залозная"
  },
  {
    "phrase": "Может быть, какому-то пользователю предложить печеньку.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Кто быстрее увольняется, тот и наверху.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "У тебя рука новая или с прошлого выступающего?",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Cringe UI library & patterns",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Я твои тренды на барчарте вертел!",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Мультиприглашение — это когда можно вбивать несколько человек за раз.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Дашборд – он резиновый.",
    "author": "Полина Васильева"
  },
  {
    "phrase": "Тут тоже монета о двух концах.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "У меня тут в интерфейсе ручки сплелись.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "Обводка, чтобы защититься от черных сайтов.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Покажи свои шары.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Я попробовала успокоить нашу аватарку.",
    "author": "Настя Залозная"
  },
  {
    "phrase": "Кто у нас шел по новому пути онбординга?",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Если ты моргнешь, то получишь ложную картинку в голове.",
    "author": "Талгат"
  },
  {
    "phrase": "Может стоит ее передать в эйчарню.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Ничего особого хайлайтового рассказать нет.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "У меня наконец-то юиксерские задачи про бабло",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Есть ли его одинаковость сейчас в Зеплине?",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Когда после отпуска команда послайсила за тебя задачу…",
    "author": "Юра Брусков"
  },
  {
    "phrase": "У нас есть вижен галереи будущего.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Кураторство — не приговор.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Обычной галочкой «Я русский» теперь не обойтись.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "А в сообщениях с @here — херня.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Зайка в трусах со статьей.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Это я не замьючен, я просто проматерился.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Почему бы не убрать эту ветку нахрен к ебентям.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Если мы ткнем в Россию, то может ничего не быть.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Меня заставляет грустить салатовая кнопка на зеленом фоне.",
    "author": "Антон Михайлов"
  },
  {
    "phrase": "Чтобы скрасить одиночество, мужика убрали.",
    "author": "Гера Павлюк"
  },
  {
    "phrase": "Твое лицо не прыгает, включи микрофон.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Не, ну сначала-то всегда все недовольны будут, чего уж.",
    "author": "Диана Прокушева"
  },
  {
    "phrase": "Глобально к обрезанию вопросов нет...",
    "author": "Таня Илюхина"
  },
  {
    "phrase": "Блять, чо так просто, давайте сложнее сделаем.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Было время, когда были Макс, Герман и девицы.",
    "author": "Рита Левкович"
  },
  {
    "phrase": "Будем делать еще более красивого паука.",
    "author": "Даша Ершова"
  },
  {
    "phrase": "Вы как-то эти данные вангуете?",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Было интересно посмотреть в глаза живого сеошника.",
    "author": "Талгат"
  },
  {
    "phrase": "А шапка больше нелегальна?",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "В будущем у нас будут такие потенциальные чуваки, но они будут такие неоплаченные.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Когда юзер сюда зайдет, вылезет окошечко с Максом.",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Это увеличивает скраллабильность.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Я сам запустился туда.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Человек умер. И забирает лайки свои в могилу.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Ну вот у нас попашка и в ней еще одна выпадашка.",
    "author": "Саша Ревенок"
  },
  {
    "phrase": "Я орнула с костюма загорелого деда.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "У формата PDF есть минус. Ты не можешь заинтерактивиться с ним.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "… я бы нарисовала человечка-андрея.",
    "author": "Рита Левкович"
  },
  {
    "phrase": "Хочу теги или подушки поставить.",
    "author": "Талгат"
  },
  {
    "phrase": "Маргарита Краснослободцева пошла в массы.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Остановить пошар.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Я такой внезапный ворвался.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Я бы хотел с тобой присесть.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Состояние, которое я не покажу, но спойлерну.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "На яябу я не попадаю.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Конверсия в зеленых бородах улучшилась.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Новый дизайн. Называется — роза-колбаса.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "2017 год Даша выкинула.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Успокой свой серый.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Что-то из этого отъедет.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Сейчас я сформулирую перед тем, как формулировать.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Команда такая: блин, опять Алина со своими фаллосами.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Из-за доступности Шейла недоступна.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Гуччи купил у нас календарь, потому что они увидели, какие там полосочки цветные.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "- Старенькие пользователи — это со скольки? - С 20",
    "author": "Алина Чурина и Саша Илющенко"
  },
  {
    "phrase": "Гугл его грохнул, чем мы хуже?",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "А с футболками у меня просто как-то не складывается",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "В неделю появляется примерно 20 корпаков.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Гугл, Яху и другие, всякие маргинальные поисковики.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Антон – повелитель круглых графиков.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "В UI отдам, а там сделают хорошо.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Вот здесь будет три два, а третьего вообще нигде не будет.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Левое меню может вообще не отдаться.",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "Ты употребляла в течение разговора некоторые виды психологии.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Круги атакуют очень. Это не только мое мнение, что круги атакуют.",
    "author": "Юля Кирикова"
  },
  {
    "phrase": "Тут на всякий случай — свистелка-перделка.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Пользователи упираются в эти грехи на каждом шагууууу.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Можно просить ахрефс выкатывать фичи, которые нам нужны.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Может хернуть в чате?",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "Ты выбрал не ту страну, чтобы улыбаться.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Тебя завтра машина переедет, а у меня твоего макета нет.",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Включи микрофон, Полина, или ты разговариваешь с растениями.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "В какой-то момент начну кричать как Годзилла.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "В середину глаз не воткнешь.",
    "author": "Аня Бирюкова"
  },
  {
    "phrase": "(Минутка знаний) Не пугайтесь, что она на 1 час.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Захватываю экран. Экран захвачен!",
    "author": "Талгат"
  },
  {
    "phrase": "Вот то дальнее ухо само по себе анимируется",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Встречались с Александром III, <…> хотим опыт перенять.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Выводы: в целом выводов никаких по этим данным нельзя сделать.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "То чувство, когда фильтруют твой стикер…",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "А когда ты андушничаешь, у нас ничего не происходит.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "Мы бы рады не соблюсти консистентность, но это сложно.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Мы юиксеры, с нами Акшура.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Это большая мамка-команда.",
    "author": "Настя Залозная"
  },
  {
    "phrase": "Меня не радуют такие разъезжающиеся дропдауны.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Так исторически… эксперимент.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Можно отлавливать людей из поисковиков…",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Можно утратить синий столбик.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Потом тебя пробиллит по полной.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Нотис не для людей, он для ютуба.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Первая опция — продаваться самим.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Кастую заклинание возврата мнения.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Тут тексты полурыбные.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Исследовала, что можно сделать с нашей шторкой.",
    "author": "Полина Васильева"
  },
  {
    "phrase": "Если мы что-то хотим отжать, то мы это отжимаем.",
    "author": "Даша Очапова"
  },
  {
    "phrase": "Можно притушить горы.",
    "author": "Антон Михайлов"
  },
  {
    "phrase": "Всякая полезная информация, маркетинговая и не очень.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Все окей ваще. О, теперь я вижу СОСОЧЕК.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Не смотри, только руке доверяй.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Если у меня новый прошник пошарит старому прошнику, то возникнут проблемы.",
    "author": "Алена Анищенко"
  },
  {
    "phrase": "Часики-то тикают! Дал бог процесс, даст и роль.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "А мы сюда и не радоваться приходим.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Это ж пока прост дизайн?)",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Спасибо за наводку на Маргариту Краснослободцеву.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Кек же все непросто.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Сейчас покажу маленькую задачку и крикну.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "А можешь дать ссылку на макет с каками?",
    "author": "Света Федина"
  },
  {
    "phrase": "Ну вот, например, жопа уже проанализирована.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Это Максим, чего вы хотите.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Он немного конвертит и немного жестокий.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Не знаю, почему мне этот глаз в голову упал.",
    "author": "Аня Бирюкова"
  },
  {
    "phrase": "… мой внутренний Виталик не одобряет.",
    "author": "Вася Дудин"
  },
  {
    "phrase": "Мама, я опять хайрил во сне!",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Встретимся свежими.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Мы хотели поддержать стиль блога, но очень сложно это сделать с фотографиями людей.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Делаю аксессибилити для белых.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "Радоваться не входит в обязанности юиксера.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Я не могу никуда уехать, у меня только коровы могут уехать.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "То есть для коров это очень важно?",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Это вводное письмо с водичкой.",
    "author": "Настя Залозная"
  },
  {
    "phrase": "Поднимайте руку и пойдем по рукам.",
    "author": "Полина Васильева"
  },
  {
    "phrase": "Смотрите, мы сделали нормальный интерфейс!",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "Плахи там вон у тебя…",
    "author": "Саша Ревенок"
  },
  {
    "phrase": "Ты вводишь домен, а потом начинается…",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "А вот здесь какой-то пичок вырос.",
    "author": "Талгат"
  },
  {
    "phrase": "Ждем альфачей в тестах.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Омежки не тестят.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "У меня на самом деле под столом еще один дизайнер сидит.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Пора написать гайд для продажных кнопок и их окружения.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Я команде уже сказал, ата-та-та-та, бля-бля-бля",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Мы все потестили, все зашло, но просто забыли вылить на прод.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "Как Даша разговаривает с людьми, если она их обходит?",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Ни с кем еще ничего не заключено, но все на крючке.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Как в Sketch эмоции вызвать?",
    "author": "Алина Чурина"
  },
  {
    "phrase": "У нас есть богатая текстареа.",
    "author": "Антон Михайлов"
  },
  {
    "phrase": "Я покоридорил — люди воодушевлены.",
    "author": "Талгат"
  },
  {
    "phrase": "Вот у тебя есть шейп рта…",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Да не надо никакого анду, он использовал свои лобные доли, теперь пусть идёт нахуй!",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Сначала, как говорится, немного секса, а потом можем получить наслаждение.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Юра — приятная часть работы с инструментами Semrush.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Скорее всего, мы от лампочек вообще уйдем.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Статью в России откуда угодно можно вытащить.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "По поводу подвальных историй…",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Напишу, что делать в случае не ОКа.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Интерфейс облегчился.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Опять будет свадьба баннеров.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "У нас есть пропса, которая делает иконки интерактивными, кликабельными, тултипельными.",
    "author": "Шейла Шейх"
  },
  {
    "phrase": "Прости, Алина, но мне показалось, что ты в камазе.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Я понажимал, и они откатили обратно.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Чекаю в Питере, в Уренгое зачекивается чекбокс.",
    "author": "Талгат"
  },
  {
    "phrase": "Мы решили сделать небольшой ресерчик.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "И дальше фейсбук что-то усиленно курил.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Для более глубокого анализа можно окунуться.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Она когда включится, я вам скажу, а вы скажете, подавилась она или нет.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Ой, теперь, блять, все хорошо!",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Это все проблема пятна.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Если не знаешь, что проверять, проверяй Position Tracking!",
    "author": "Ребята на синке про inputNumber компонент"
  },
  {
    "phrase": "До нас добежал позитивный тест.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Секта свидетелей Семраша.",
    "author": "Полина Васильева"
  },
  {
    "phrase": "Тони тащит в доне.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Хочется, чтобы они тоже были посмелее, как табины.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Я вписался в какую-то штуку, пока еще не понял, какую.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Нет бога кроме матушки акшуры.",
    "author": "Полина Васильева"
  },
  {
    "phrase": "Нужно причесать интерфейс не только спереди, но и сзади.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Говорите как петербуржцы, не демо, А ТРЕНИНГ.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "А у тех, кто не молодцы, у них блокирующий спиннер.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Всякие апельсинки-мандиринки можно повесить на кнопки.",
    "author": "Саша Ревенок"
  },
  {
    "phrase": "Он вот этих активирует и пойдет кикнет ведром трех неугодных",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Можешь добавить себе еще какой-нибудь асинчик.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Щас будем коннектиться в одну струю.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Алина Краснослободцева тоже теперь помещается.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Ты хорошо сидишь на стуле, но можешь сидеть еще лучше.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Лендинг не для пользователей, а для Фейсбука.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Может быть, я немножко не свежий человек уже.",
    "author": "Ксюша Видищева"
  },
  {
    "phrase": "Это не шапка, это шляпа.",
    "author": "Даша Юдашкина"
  },
  {
    "phrase": "Попрошу нарисовать менее шумно.",
    "author": "Даша Очапова"
  },
  {
    "phrase": "Сперва ты чекбоксишь главный чекбокс, а потом чекбоксишь маленькие чекбоксики.",
    "author": "Рита Левкович"
  },
  {
    "phrase": "Пользователь попал на основной Semrush и всё! На этом и заканчивается путь!",
    "author": "Света Федина"
  },
  {
    "phrase": "Может, сделать хотя бы урл у этой попапки?",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Я решила взять помоложе, убрать бородачей.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Залогинься и получи лимит!",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Если я участник, то я могу выпилиться...",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Можно задействовать шляпу и зайцев.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Ой, сейчас вообще староверы придут с бумажными прототипами.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Семрашевская резня рейтингом агентств.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Так, давайте не будем слушать больных людей.",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Я могу тыкать в людей?",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Это настолько сложно, что хочется даже плакать.",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "PDF-ка далеко не секси.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Думал когда-то, но потом перестал.",
    "author": "Талгат"
  },
  {
    "phrase": "Леша кекает над радужными горами",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "- А при чем тут big data? - Big data, Даша, всегда при чем.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Просто орать, главное — красиво, и вспоминай деда. Орать будет дед, а не ты.. ну то есть звук деда.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Там Макс усики теребит, а мы не видим.",
    "author": "Антон Михайлов"
  },
  {
    "phrase": "У него, кстати, борода нарисованная.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Есть, понятно, кто-то где-то, но непонятно, кто и где.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Один плюс, и я иду обедать.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "А тут у нас дропдауни младший.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Попробую продавить через ПэОшечную.",
    "author": "Вася Дудин"
  },
  {
    "phrase": "Представим, что единственное консистентное решение у нас на Semrush, это алфавит.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Я полчаса рисовал котику нос.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Я туда тоже заложил двух человек.",
    "author": "Андрей Силаев"
  },
  {
    "phrase": "А, так, ладно, мужичок нормальный.",
    "author": "Гера Павлюк"
  },
  {
    "phrase": "Но текстареа не станет от этого беднее.",
    "author": "Макс Черемных"
  },
  {
    "phrase": "My Reports — это место, где живут PDF-ки.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Желательно, чтобы как можно меньше жопы у нас было, а нормальная работа.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Так, почему я отшарился?",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Поиграй с нежностью.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Люди мои уже верстают.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "Она актуальна, но не 100%.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Херы иногда пролетают мимо, у меня тоже так изредка.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Затестил чат для тестов.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Может быть, как-то гасить подсказки…",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Сори. Тупанул.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Макс, не хочешь немного импотенции?",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Короче, это опасный контрол.",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "Лид юнита уходит из команды строить свой парк с бюджетом и юхами.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "… забор как-то сильно контрастирует по визуальному весу по отношению к персонажу.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Меняем логику построения пузырьков.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "А это вью на на-на-нано-листе!",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Я хотел проглотить опыт других компаний.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Квазавр будет дружком кита.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Location ne vlezli",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Дизайн седлали довольно быстро.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "А я все равно ничего не показываю Герману, кроме гейского порно.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Дизайнеры играют со шрифтами, разработчики с z-индексами.",
    "author": "Шейла Шейх"
  },
  {
    "phrase": "Я бы здесь показывала кликнутость.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "У нас есть целый дата-саентист.",
    "author": "Андрей Фатеев"
  },
  {
    "phrase": "Последняя штука — это фантазии фронта.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Эти проблемы более-менее печальные, но не критичные.",
    "author": "Шейла Шейх"
  },
  {
    "phrase": "Выключил монитор, но все ровно вижу боль.",
    "author": "Гера Павлюк"
  },
  {
    "phrase": "Хочется убежать тоже, но бежать некуда......",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Кому не хватает кринжа по утрам",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Поехавшим иконкам поехавшие дизайнеры.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Не, ну прозрачные тултипы сайт аудита это охуенно.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Подождите, грузим ошибку.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Мы словом эксперимент прикрываем любую вакханалию в своем инструменте.",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "Секс оказался популярнее, чем Юра.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Думаю, надо обмудить.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "У меня была интересная неделя, ничего интересного.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Мы лелеяли планы поджать фришников.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "Исчезнут наши бородатые мужики.",
    "author": "Алсу Газиева"
  },
  {
    "phrase": "Жесткий мужик, но чет витрине и, правда, без него одиноко.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Триальщик седьмого дня.",
    "author": "Диана Прокушева"
  },
  {
    "phrase": "Не хочется идти в твиттер и рассказывать, что у меня в инструменте тыква.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Почему нельзя отрадиобаттонить?",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Простите, но с мужиками не вышло в этот раз.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Подойди, я покажу тебе, как решить проблему колбасок.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Это не очень дружелюбная конструкция.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "А там, если уже человек извращенец, будет все отчёркивать.",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Здесь нет, но вы можете себе вообразить.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Кажется, мы договорились как-то реагировать на сообщения с хер.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "А кидайте мне фидбек, от PO и людей.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Не хочу бороться за фаллического дружочка.",
    "author": "Алина Чурина"
  },
  {
    "phrase": "За рабочими местами мы совсем не дружелюбные все",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Кашу мы никаким дизайном не сможем убрать.",
    "author": "Настя Залозная"
  },
  {
    "phrase": "Ахрефс делает нас лучше.",
    "author": "Саша Илющенко"
  },
  {
    "phrase": "Кстати, кто в аду, тому сложнее всего.",
    "author": "Саша Ревенок"
  },
  {
    "phrase": "Ого, поставьте счетчик, что у вас осталось 9 кликов. Не кажется, что вы злые?",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Перевел бабушку… на бизнес.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Я увидел твою историю с распепячкой.",
    "author": "Талгат"
  },
  {
    "phrase": "Можешь у меня новые пилюльки взять потестить. Они уродские, но вдруг нет.",
    "author": "Гера Павлюк"
  },
  {
    "phrase": "Меня уже укачало, как я листаю страницу.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Чо они там хотят делать в своем департаменте с дизайнерами.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "У нас очередной порыв жадности.",
    "author": "Даша Ершова"
  },
  {
    "phrase": "Там, где пальчик засовываешь, нажимаешь и держишь.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Отсобесятся там у себя.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Да, ребята объясняли, как это будет работать. Слышала однажды — не повторю этих слов.",
    "author": "Алина Чурина"
  },
  {
    "phrase": "Сначала был план зарезать. У нас был план взять вот эту всю базу взрослого контента и зарезать.",
    "author": "Даша Ершова"
  },
  {
    "phrase": "Он должен был помочь, но от него ничего не надо было, поэтому он ничем не помог.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "А почему у Германа штатив в кошачьем туалете?",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Нажми на зайку.",
    "author": "Герман Иванов"
  },
  {
    "phrase": "Не было ни хере, ни ченал.",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Я могу провалиться в лошадей.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Если кто-то тут закомментировал, то мы все под Алексеем.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "У меня есть идея, чем заполнить пустоту.",
    "author": "Гера Павлюк"
  },
  {
    "phrase": "Пилить пилюлю оказалось трудно, поэтому команда запилила целую табину.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Я по поводу обрезания...",
    "author": "Саша Ревенок"
  },
  {
    "phrase": "SEO-дашбардак.",
    "author": "Рита Левкович"
  },
  {
    "phrase": "Поаккуратнее с бесконтрольными выделениями пользователей.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Еще покопавшись, я начал ковырять вот эти вот кружочки.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Тут он шлется в одно место.",
    "author": "Марина Тивякова"
  },
  {
    "phrase": "Я, возможно, погорячился, перегрелся.",
    "author": "Макс Совенков"
  },
  {
    "phrase": "Что-то мы как-то заленились.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Увольняли и нормас.",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Фигосики-абрикосики!",
    "author": "Диана Прокушева"
  },
  {
    "phrase": "Нет почты — нет сердечка.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Планируем интеграцию с ЛГБТ.",
    "author": "Талгат"
  },
  {
    "phrase": "Это у нас процесс инициализации. Какать радугой…",
    "author": "Лена Голубева"
  },
  {
    "phrase": "Холодные люди, которые ничего о тебе не знают.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "Мне кажется удалось вызвать Сатану своим интерфейсом.",
    "author": "Антон Дуканич"
  },
  {
    "phrase": "Это просто наколеночные тексты.",
    "author": "Сережа Фоменко"
  },
  {
    "phrase": "Я слышала там одну ручку.",
    "author": "Яна Макшинова"
  },
  {
    "phrase": "Ты очень эмоционально выглядишь, но микрофон лучше включи.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Это топовый топик.",
    "author": "Света Федина"
  },
  {
    "phrase": "Я за тот вариант, который ты не нарисовал.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "Я хотела пристать к тултипу.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Нет проблем в том, что у нас каша.",
    "author": "Даша Ершова"
  },
  {
    "phrase": "Ты бы в человека хотела провалиться?",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "С тех пор ее никто не теребил.",
    "author": "Юра Брусков"
  },
  {
    "phrase": "Стандартная, внутри немножко переделанная.",
    "author": "Лера Кузнецова"
  },
  {
    "phrase": "Кажется, это предел впихуемости.",
    "author": "Лёша Ардов"
  },
  {
    "phrase": "А уровень кринжа когда-нибудь в этой трансляции снизится?",
    "author": "Серега Кривой"
  },
  {
    "phrase": "Они могут нарисовать что-то вместо этой дырки.",
    "author": "Аня Бирюкова"
  },
  {
    "phrase": "Я попросила в сербской аптеке что-то для носа, и мне дали порошок.",
    "author": "Мила Титова"
  },
  {
    "phrase": "В пятницу сдаю пальцы.",
    "author": "Мила Титова"
  },
  {
    "phrase": "Дружочек, ты потерял ссылки.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Я, кстати, адвокат 🥑",
    "author": "Серёга Токарев"
  },
  {
    "phrase": "Приехала сестра, а значит запахло мясом 🍖",
    "author": "Женя Расчетов"
  },
  {
    "phrase": "Неприятно, как будто я в Амстердаме.",
    "author": "Лера Крупина"
  },
  {
    "phrase": "У меня на счету есть евро и доллары, меня не волнуют остальные currencies 💅",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Семраш подложит им подушечку.",
    "author": "Макс Черемных"
  },
  {
    "phrase": "Через три дня я должна стать огурцом 🥒",
    "author": "Ира"
  },
  {
    "phrase": "Там были старые люди лет тридцати.",
    "author": "Женя Расчетов"
  },
  {
    "phrase": "Он уехал во вселенную рандеву с картошкой.",
    "author": "Макс Черемных"
  },
  {
    "phrase": "Кумкват откинул ягоды и коньки.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Я вижу булочку 🍞",
    "author": "Катя Мишина"
  },
  {
    "phrase": "Плюсую Алине про жирноту.",
    "author": "Даша Очапова"
  },
  {
    "phrase": "Я добавила мужику немного тела.",
    "author": "Лера Крупина"
  },
  {
    "phrase": "Можно было бы этого мужичка докрутить.",
    "author": "Наки Баймурзаева"
  },
  {
    "phrase": "Обычно люди... ну как – люди. Наши пользователи.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "у меня ручка торчит по поводу того, что Алсу говорила.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Религия UX не признаёт отрезаний.",
    "author": "Саша Щербакова"
  },
  {
    "phrase": "У нас в беклинк аудите висит грустный мужик, и юзеров это вообще не смущает.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "У меня есть необузданное желание засунуть мини-бананы во все графики.",
    "author": "Серёжа Токарев"
  },
  {
    "phrase": "Он умрет через 7 дней, если не избавится от токсичных беклинок.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "у нас убрали котов и поставили бородатого мужика.",
    "author": "Полина Васильева"
  },
  {
    "phrase": "Он открыл дроп-даун и снова ткнул, и ткнул, и ткнул.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Я теперь Ниндзя Самураевна.",
    "author": "Яна Макшинова"
  },
  {
    "phrase": "Я растянула контент на всю ширину, потому что не надо стесняться.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "У нас тут есть один блок советского периода.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Это пупок бегемота.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Исследую прелести немецких стоматологов.",
    "author": "Антон Михайлов"
  },
  {
    "phrase": "Навигация идёт по ушкам.",
    "author": "Даша Юдашкина"
  },
  {
    "phrase": "Нужно поменять и изменить.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Мы становимся жёстче и конкретнее.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Ивенты у нас повешены.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "Тома висит уже давно.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Мы выбрали пики.",
    "author": "Алина Краснослободцева"
  },
  {
    "phrase": "Надо быстро закрыть техническую дырку.",
    "author": "Серёга Токарев"
  },
  {
    "phrase": "Там ещё кот не валялся.",
    "author": "Даша Прокудина"
  },
  {
    "phrase": "Вчера был неприятный ноль.",
    "author": "Макс Черемных"
  },
  {
    "phrase": "Я могу себе вправить палец.",
    "author": "Женя Расчетов"
  },
  {
    "phrase": "Когда я делаю UI, я забываю шевелиться.",
    "author": "Женя Расчетов"
  },
  {
    "phrase": "Смотрел, как ребята кувыркаются с мотоциклами. Мне тоже хотелось кувыркаться с ними.",
    "author": "Женя Расчетов"
  },
  {
    "phrase": "Произошёл несложный расчётов.",
    "author": "Тома Каменцева"
  },
  {
    "phrase": "аш ти ти пи даби даби даби точка.",
    "author": "Надя Раваева"
  },
  {
    "phrase": "Бомбошка.",
    "author": "Тома Каменцева"
  }
];
